// extracted by mini-css-extract-plugin
module.exports = {"formItem":"_2JfOKXLSgf55L46Cf7Don5"};